var exports = {
  "kL": "x234b8571--901247--container",
  "Sl": "x234b8571--901247--image",
  "Qs": "x234b8571--901247--content",
  "L1": "x234b8571--901247--content-title",
  "S8": "x234b8571--901247--content-title--with-description",
  "QN": "x234b8571--901247--modal-container",
  "Tz": "x234b8571--901247--modal-heading",
  "Y8": "x234b8571--901247--modal-content",
  "LY": "x234b8571--901247--modal-info-container",
  "cR": "x234b8571--901247--modal-image-container",
  "ky": "x234b8571--901247--modal-image",
  "h_": "x234b8571--901247--description",
};

module.exports = exports;
